__turbopack_context__.v({
  "animate": "main-sidebar-module-sass-module__5H5zfG__animate",
  "content": "main-sidebar-module-sass-module__5H5zfG__content",
  "gamesCount": "main-sidebar-module-sass-module__5H5zfG__gamesCount",
  "mainSidebar": "main-sidebar-module-sass-module__5H5zfG__mainSidebar",
  "popoverContent": "main-sidebar-module-sass-module__5H5zfG__popoverContent",
  "separator": "main-sidebar-module-sass-module__5H5zfG__separator",
  "subNav": "main-sidebar-module-sass-module__5H5zfG__subNav",
  "subNavItem": "main-sidebar-module-sass-module__5H5zfG__subNavItem",
});
